import axios from "axios";
import { CALCULATE_URL, CALHISTORY_URL } from "../constant";
import Moment from "moment";
import calStore from "./calculateStore";
const { decorate, observable, action } = require("mobx");

class calHistory {
  hisList = [];
  lastDay;
  noEdit=0;

  async getList() {
    try {
      let response = await axios.get(CALHISTORY_URL);
      let data = await response.data;
      this.hisList = data;
      this.getLastId();
      if(data)
        this.lastDay = data[data.length-1].endDt;
      return data;
    } catch (error) {

      console.log(error);
 
    }
  }

  async addHistory(noEdit) {  //id 넘기기
    try {
      const datelist = calStore.getDate();
      const data = await calStore.getTransfer(noEdit);
      const idlist = calStore.getId();
      let response = await axios.post(CALHISTORY_URL+"/prevID/?prevID="+noEdit, {
        month: Number(Moment(datelist[1]).format("MM")),    //정산 month
        // sequence: 0, //sequence,
        transfer: data, // transfer,
        startDt: Moment(datelist[0]),
        endDt: Moment(datelist[1]),
        startId: idlist[0],
        endId: idlist[1],
      });

      this.lastDay = datelist[1];
      this.noEdit = idlist[1];
      await this.getList();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getLastId() {
    let response = await axios.get(CALHISTORY_URL+"/lastid/");
    let data = await response.data;
    try {
      this.noEdit = data[0].endId;
      calStore.getLastHistory(data[0].endId)
    } catch(e) {

    }
  }
}

decorate(calHistory, {
  lastDay: observable,
  noEdit: observable,
  hisList: observable,
  getList: action,
  addHistory: action,
  getLastId: action,
});

const init = new calHistory();
export default init;
// GET: 조회 get
// POST: 등록 add
// PUT: 수정 update
// DELETE: 제거 delete